/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DocumentSubType,
    DocumentSubTypeFromJSON,
    DocumentSubTypeFromJSONTyped,
    DocumentSubTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ObjectionVariant
 */
export interface ObjectionVariant {
    /**
     * 
     * @type {number}
     * @memberof ObjectionVariant
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ObjectionVariant
     */
    objectionId: number;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    ownerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    additionalContent?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectionVariant
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectionVariant
     */
    isDeleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    sharedWithFirmId?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ObjectionVariant
     */
    tagIds?: Array<number> | null;
    /**
     * 
     * @type {DocumentSubType}
     * @memberof ObjectionVariant
     */
    documentSubType?: DocumentSubType;
    /**
     * 
     * @type {string}
     * @memberof ObjectionVariant
     */
    caseTypeId?: string | null;
}

export function ObjectionVariantFromJSON(json: any): ObjectionVariant {
    return ObjectionVariantFromJSONTyped(json, false);
}

export function ObjectionVariantFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObjectionVariant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'objectionId': json['objectionId'],
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'name': json['name'],
        'content': json['content'],
        'additionalContent': !exists(json, 'additionalContent') ? undefined : json['additionalContent'],
        'isDefault': json['isDefault'],
        'isDeleted': json['isDeleted'],
        'sharedWithFirmId': !exists(json, 'sharedWithFirmId') ? undefined : json['sharedWithFirmId'],
        'tagIds': !exists(json, 'tagIds') ? undefined : json['tagIds'],
        'documentSubType': !exists(json, 'documentSubType') ? undefined : DocumentSubTypeFromJSON(json['documentSubType']),
        'caseTypeId': !exists(json, 'caseTypeId') ? undefined : json['caseTypeId'],
    };
}

export function ObjectionVariantToJSON(value?: ObjectionVariant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'objectionId': value.objectionId,
        'ownerId': value.ownerId,
        'name': value.name,
        'content': value.content,
        'additionalContent': value.additionalContent,
        'isDefault': value.isDefault,
        'isDeleted': value.isDeleted,
        'sharedWithFirmId': value.sharedWithFirmId,
        'tagIds': value.tagIds,
        'documentSubType': DocumentSubTypeToJSON(value.documentSubType),
        'caseTypeId': value.caseTypeId,
    };
}


